export const UPDATE_PAYMENT_TOKEN = 'update_payment_token'
export const CREATE_PAYMENT_TOKEN = 'create_payment_token'
export const FUNDING_TRANSACTION = 'sale'
